import api from '../api';

/**
 * Sets a notification.
 *
 * @param {string} title - The title of the notification.
 * @param {string} content - The content of the notification.
 * @param {Date} date - The date of the notification.
 * @param {Date} startDate - The start time of the notification.
 * @param {Date} endDate - The end time of the notification.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const saveNotification = async (id,title, content, date, startDate, endDate) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/notification/save`;
  const requestData = {
    id,
    title,
    content,
    date,
    start_date: startDate,
    end_date: endDate
  };
  try {
    const response = await api.post(endpoint, requestData);

    return response.data;
  } catch (error) {
    console.error('Error setting notification:', error);
    throw error;
  }
}

export default saveNotification;
